import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface StreamingMarkdownProps {
  content: string;
  className: string;
  showCursor?: boolean;
}

/**
 * StreamingMarkdown — renders markdown with an inline animated blue dot cursor
 * at the very end of the content (like Claude/ChatGPT).
 *
 * Uses a CSS class `streaming-active` that targets the last text-containing
 * element via CSS `::after` pseudo-element — no DOM manipulation needed.
 */
export function StreamingMarkdown({ content, className, showCursor = true }: StreamingMarkdownProps) {
  return (
    <div className={showCursor ? "streaming-active" : undefined}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} className={className}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
